import React, { Component } from "react";
import "./GenerateQrCode.css";
import QRCode from "qrcode.react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import coin from "./images/icon_coin_balance.png";
// Change language
import PropTypes from "prop-types";
import en from "./languages/en.json";
import th from "./languages/th.json";

// Translation Higher Order Component
import {
  setTranslations,
  setDefaultLanguage,
  setLanguageCookie,
  setLanguage,
  translate,
} from "react-switch-lang";

// Do this two lines only when setting up the application
setTranslations({ en, th });
// setDefaultLanguage("th");

// If you want to remember selected language
setLanguageCookie();

const apiUrl =
  "https://centapi.andamandaphuket.com:8443/centaman.api/v3/giftcards?GiftcardNo=";

class GenerateQrCode extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      current: 0,
    };
  }

  handleChange(event) {
    setLanguage(event.target.value);
    this.wristbandInput.focus();
  }

  componentDidMount() {
    // Start counting when the page is loaded
    // this.timeoutHandle = setTimeout(() => {
    //   setLanguage("th")
    //   this.props.history.push("/");
    // }, 10000);
    this.wristbandInput.focus();
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutHandle);
  }

  // getUserDetail = async (wristband) => {
  //   try {
  //     const response = await fetch(apiUrl + wristband, {
  //       method: "GET",
  //       headers: { Authorization: "Basic " + btoa("ANDAMAPI:200acabovul") },
  //     });
  //     const result = await response.json();
  //     const userDetail = result[0];
  //     if (userDetail) {
  //       //3322780051
  //       this.wristbandInput.value = "";
  //       this.setState({ wristband: "" });
  //       this.props.history.push({
  //         pathname: "/page3",
  //         state: {
  //           giftcardNo: userDetail.GiftcardNo,
  //           giftcardExpiryDate: userDetail.GiftcardExpiryDate,
  //           cashOutBalance: userDetail.CashOutBalance,
  //           restrictedBalance: userDetail.RestrictedBalance,
  //           totalBalance: userDetail.TotalBalance,
  //         },
  //       });
  //     } else {
  //       this.wristbandInput.value = "";
  //       this.setState({ wristband: "" });
  //     }
  //   } catch (error) {
  //     this.wristbandInput.value = "";
  //     this.setState({ wristband: "" });
  //     this.props.history.push({
  //       pathname: "/page5",
  //       state: {

  //       },
  //     });
  //   } finally {
  //     // setLoading(false);
  //   }
  // };

  getUserDetail = (wristband) => {
    return new Promise((resolve, reject) => {
      fetch(apiUrl + parseInt(wristband), {
        method: "GET",
        headers: { Authorization: "Basic " + btoa("ANDAMAPI:200acabovul") },
      })
        .then((response) => response.json())
        .then((result) => {
          const userDetail = result[0];

          if (userDetail) {
            this.wristbandInput.value = "";
            this.setState({ wristband: "" });

            const stateData = {
              giftcardNo: userDetail.GiftcardNo,
              giftcardExpiryDate: userDetail.GiftcardExpiryDate,
              cashOutBalance: userDetail.CashOutBalance,
              restrictedBalance: userDetail.RestrictedBalance,
              totalBalance: userDetail.TotalBalance,
            };

            this.props.history.push({
              pathname: "/page3",
              state: stateData,
            });

            resolve(stateData);
          } else {
            this.wristbandInput.value = "";
            this.setState({ wristband: "" });
            resolve(null); // Resolve with null to indicate no user detail
          }
        })
        .catch((error) => {
          this.wristbandInput.value = "";
          this.setState({ wristband: "" });

          this.props.history.push({
            pathname: "/page5",
            state: {
              wristband: wristband,
            },
          });

          reject(error); // Reject with the error
        })
        .finally(() => {
          // setLoading(false);
        });
    });
  };

  // handleWristbandKeyDown = (e) => {
  //   if (e.key === "Enter") {
  //     console.log("Enter press...", e.target.value);
  //     this.setState({ wristband: e.target.value });
  //     this.getUserDetail(e.target.value);
  //   }
  // };

  handleWristbandKeyDown = (e) => {
    if (e.key === "Enter") {
      this.setState({ wristband: e.target.value });
      this.getUserDetail(e.target.value)
        .then((stateData) => {
          if (stateData === null) {
            // Handle case where no user detail was found
            console.log("No user detail found");
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  };

  render() {
    const { t } = this.props;
    const giftcardNo = this.props.location.state?.giftcardNo;
    const qrGiftcardNo = `ANDKIOSK-${giftcardNo}`;
    const totalBalance = this.props.location.state?.totalBalance;
    return (
      <div className="main" onClick={() => this.wristbandInput.focus()}>
        <input
          style={{
            opacity: "0",
            width: 0,
            height: 0,
          }}
          autoFocus={true}
          onKeyDown={this.handleWristbandKeyDown}
          ref={(inputEl) => (this.wristbandInput = inputEl)}
        />
        <div>
          <div className="leftSection">
            {/* <div className="txtWristbandID">
              {t("wristbandID")} <br />
              {giftcardNo}
            </div> */}
            <div className="txtBalance">
              {totalBalance}
              <img src={coin} className="imgCoin" />
            </div>
            <div className="txtAvailableBalance">{t("availableBalance")}</div>
          </div>
          <div className="rightSectionBg"></div>
          <div className="rightSection">
            <div className="txtConnect">
              {t("easyToConnet")} <br />
              {t("byAndamanda")}
            </div>
            <div className="qrCodeContainer">
              <QRCode
                value={qrGiftcardNo}
                size="222"
                renderAs="svg"
                level={"H"}
                fgColor="#333"
                bgColor="#fff"
                key={`level-H`}
                style={{
                  marginTop: "13px",
                  marginBottom: "13px",
                  marginLeft: "10px",
                  marginRight: "10px",
                }}
              />
              <div className="seeInstructionContainer">
                {/* <Link
                  to={{
                    pathname: "/page4",
                    param: {
                      giftcardNo: giftcardNo,
                    },
                  }}
                  style={{
                    textDecoration: "none",
                    color: "#F4327B",
                    fontSize: "36px",
                  }}
                >
                  {t("seeInstruction")}
                </Link> */}
              </div>
            </div>
          </div>
          <div className="buttonContainer">
            <Link
              to={"/page1"}
              style={{
                textDecoration: "none",
              }}
            >
              <Button
                variant="contained"
                style={{
                  background:
                    "linear-gradient(90deg, #EC008C 0%, #FC6767 100%)",
                  color: "#FFFFFF",
                  borderRadius: "20px",
                  width: "317px",
                  height: "112px",
                  marginLeft: "40%",
                  marginTop: "50px",
                  fontSize: "36px",
                }}
                onClick={() => setLanguage("th")}
              >
                {t("done")}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

GenerateQrCode.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(GenerateQrCode);
